import { Component } from '@angular/core';

@Component({
  selector: 'common-external-link-icon',
  templateUrl: './external-link-icon.component.svg',
  styleUrls: ['./external-link-icon.component.scss'],
})
export class ExternalLinkIconComponent {}
